import React from 'react';
import { compose, withHandlers, withProps, withStateHandlers } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import keyGenerator from 'utils/keys';
import { constants as dateAndTimeConstants } from 'utils/dateAndTimes';
import {
  actions as shipmentActions,
  selectors as shipmentSelectors,
} from 'state/shipments';
import { isEmpty } from 'utils/types';

import TimePickers from 'components/form/TimePickers/component';

const enhance = compose(
  withTranslation('timePickers'),
  connect(
    (state, { stopType, shipmentKey }) => ({
      values: shipmentSelectors.getShipmentTimesRaw(
        state,
        shipmentKey,
        stopType
      ),
      errors: shipmentSelectors.getShipmentTimesErrors(
        state,
        shipmentKey,
        stopType
      ),
      warnings: shipmentSelectors.getShipmentTimesWarnings(
        state,
        shipmentKey,
        stopType
      ),
    }),
    {
      changeTime: shipmentActions.changeTime,
      selectTime: shipmentActions.selectTime,
      onBlurTimePicker: shipmentActions.onBlurTimePicker,
    }
  ),
  withProps(({ t, errors, warnings, shipmentKey, stopType, values }) => ({
    fromValue: values[dateAndTimeConstants.TIME_FIELD_PARAMS.from],
    toValue: values[dateAndTimeConstants.TIME_FIELD_PARAMS.to],
    fromId: keyGenerator.time.from({ shipmentKey, stopType }),
    toId: keyGenerator.time.to({ shipmentKey, stopType }),

    timeFieldFrom: dateAndTimeConstants.TIME_FIELD_PARAMS.from,
    timeFieldTo: dateAndTimeConstants.TIME_FIELD_PARAMS.to,

    fromWarning: warnings[keyGenerator.time.from({ shipmentKey, stopType })],
    toWarning: warnings[keyGenerator.time.to({ shipmentKey, stopType })],

    fromError: (errors[keyGenerator.time.from({ shipmentKey, stopType })] ||
      [])[0],
    toError: (errors[keyGenerator.time.to({ shipmentKey, stopType })] || [])[0],

    toLabel: t('to_label'),
    fromLabel: t('from_label'),
    errorLabel: t('error_label'),
  })),
  withTranslation('timePickers'),
  withStateHandlers(
    ({ isFormFocusedAndNoTyped = false, isToFocusedAndNoTyped = false }) => ({
      isFormFocusedAndNoTyped,
      isToFocusedAndNoTyped,
    }),
    {
      handleFocusFromState:
        () =>
        (state = true) => ({
          isFormFocusedAndNoTyped: state,
        }),
      handleFocusToState:
        () =>
        (state = true) => ({
          isToFocusedAndNoTyped: state,
        }),
    }
  ),
  withHandlers(() => {
    let responsiveModalFromRef = React.createRef();
    let responsiveModaToRef = React.createRef();

    return {
      handleChangeFrom:
        ({
          changeTime,
          shipmentKey,
          stopType,
          isFormFocusedAndNoTyped,
          handleFocusFromState,
        }) =>
        (_, { value, diffDay, closeModal = false }) => {
          changeTime({
            timeParam: dateAndTimeConstants.TIME_FIELD_PARAMS.from,
            stopType,
            value,
            shipmentKey,
            diffDay,
          });
          if (closeModal && responsiveModalFromRef)
            responsiveModalFromRef.close();
          if (isFormFocusedAndNoTyped) handleFocusFromState(false);
        },
      handleChangeTo:
        ({
          changeTime,
          shipmentKey,
          stopType,
          isToFocusedAndNoTyped,
          handleFocusToState,
        }) =>
        (_, { value, diffDay, closeModal = false }) => {
          changeTime({
            timeParam: dateAndTimeConstants.TIME_FIELD_PARAMS.to,
            stopType,
            value,
            shipmentKey,
            diffDay,
          });
          if (closeModal && responsiveModaToRef) responsiveModaToRef.close();
          if (isToFocusedAndNoTyped) handleFocusToState(false);
        },
      handleSelectFrom:
        ({ selectTime, shipmentKey, stopType }) =>
        (_, { value, diffDay, closeModal = false }) => {
          selectTime({
            timeParam: dateAndTimeConstants.TIME_FIELD_PARAMS.from,
            stopType,
            value,
            shipmentKey,
            diffDay,
          });
          if (closeModal && responsiveModalFromRef)
            responsiveModalFromRef.close();
        },
      handleSelectTo:
        ({ selectTime, shipmentKey, stopType }) =>
        (_, { value, diffDay, closeModal = false }) => {
          selectTime({
            timeParam: dateAndTimeConstants.TIME_FIELD_PARAMS.to,
            stopType,
            value,
            shipmentKey,
            diffDay,
          });
          if (closeModal && responsiveModaToRef) responsiveModaToRef.close();
        },
      handleBlurFrom:
        ({ onBlurTimePicker, stopType, shipmentKey }) =>
        () => {
          onBlurTimePicker({
            timeParam: dateAndTimeConstants.TIME_FIELD_PARAMS.from,
            stopType,
            shipmentKey,
          });
        },
      handleBlurTo:
        ({ onBlurTimePicker, stopType, shipmentKey }) =>
        () => {
          onBlurTimePicker({
            timeParam: dateAndTimeConstants.TIME_FIELD_PARAMS.to,
            stopType,
            shipmentKey,
          });
        },
      responsiveModalFromRef: () => (ref) => {
        responsiveModalFromRef = ref;
      },
      responsiveModalToRef: () => (ref) => {
        responsiveModaToRef = ref;
      },
      handleFocusFrom:
        ({ fromId, handleFocusFromState }) =>
        () => {
          if (!isEmpty(fromId) && !isEmpty(document.getElementById(fromId))) {
            try {
              document.getElementById(fromId).select();
            } catch (err) {
              console.log('E', err);
            }
          }

          handleFocusFromState();
        },
      handleFocusTo:
        ({ toId, handleFocusToState }) =>
        () => {
          if (!isEmpty(toId) && !isEmpty(document.getElementById(toId))) {
            document.getElementById(toId).select();
          }
          handleFocusToState();
        },
    };
  })
);

export default enhance(TimePickers);
export { TimePickers, enhance };
